import React from 'react'
import {Box, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {PAYMENT_COLORS} from './constants'

export default function GatewayEnvironmentPill({
  environment,
  active,
}: {
  environment: 'sandbox' | 'live'
  active: boolean
}) {
  const {t} = useTranslation()
  const envLabel =
    environment === 'live'
      ? (t('payment.status.live') as string)
      : (t('payment.status.sandbox') as string)
  const stateLabel = active
    ? (t('payment.status.active') as string)
    : (t('payment.status.inactive') as string)

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap='6px'
      sx={{
        display: 'inline-flex',
        px: '8px',
        py: '4px',
        borderRadius: '4px',
        backgroundColor: PAYMENT_COLORS.background,
        border: `1px solid ${PAYMENT_COLORS.border}`,
      }}
    >
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: active ? PAYMENT_COLORS.success : PAYMENT_COLORS.error,
        }}
      />
      <Typography fontSize={12} color={PAYMENT_COLORS.textSecondary}>
        {envLabel}: {stateLabel}
      </Typography>
    </Stack>
  )
}
